import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectActiveEntitiesArray } from '../../services/entities/selectors';
import { makeSelectEntityTypeValue } from '../../services/entityTypes/selectors';
import { selectCurrentEntityId } from '../../services/currentEntityId/selectors';
import { makeSelectQueryStringNumberValue } from '../../workspaces/react-router-selectors';

// Utils
import orderBy from '../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);
const selectEntityTypeId = (state, props) => props.entityTypeId;
const selectResetOnGroupCreation = (state, props) => props.resetOnGroupCreation;

const selectFilteredData = createDeepEqualSelector(
    [selectActiveEntitiesArray, selectEntityTypeId],
    (activeEntitiesArray, entityTypeIdState) =>
        activeEntitiesArray.filter(value => {
            if (entityTypeIdState && entityTypeIdState !== value.entityTypeId) {
                return false;
            }
            return true;
        })
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'name')
);

const selectOptions = createDeepEqualSelector(
    [selectOrderedData, makeSelectEntityTypeValue('pluralName')],
    (orderedDataState, entityTypePluralNameState) =>
        [
            {
                key: 0,
                text: `All ${entityTypePluralNameState}`,
                value: 0
            }
        ].concat(
            orderedDataState.map(({ id, name }) => ({
                key: id,
                text: name,
                value: id
            }))
        )
);

const selectEntityId = createDeepEqualSelector(
    [
        selectCurrentEntityId,
        makeSelectQueryStringNumberValue('selectedCurrentEntityId'),
        makeSelectQueryStringNumberValue('newGroup'),
        selectResetOnGroupCreation
    ],
    (globallySelectedCurrentEntityId, selectedCurrentEntityId, newGroupId) => {
        if (newGroupId && selectResetOnGroupCreation) {
            return 0;
        }
        if (!selectedCurrentEntityId && selectedCurrentEntityId !== 0) {
            return globallySelectedCurrentEntityId;
        }
        return selectedCurrentEntityId;
    }
);

export { selectOptions, selectEntityId };
